import "./layout.scss";
import { NavLink } from "react-router-dom";
import LayoutStudent from "src/components/layout/LayoutStudent/LayoutStudent";
import LayoutHeader from "src/components/layout/LayoutHeader";
import { Crumb } from "src/components/Breadcrumb";
import LayoutCompany from "src/components/layout/LayoutCompany/LayoutCompany";
import { useParseBackUrl } from "src/hooks/useBackUrl";
import SEO from "src/components/layout/SEO";
import useAuth from "src/hooks/selectors/useAuth";
import { useTranslation } from "react-i18next";
import { useContext } from "react";
import { ModalViewContext } from "src/components/layout/ModalView";

interface LayoutProps {
	children?: any;
	loading?: boolean;
	title?: any;
	subtitle?: any;
	className?: string;
	hideCtaButton?: boolean;
	hideNav?: boolean;
	actions?: any;
	sidebar?: any;
	breadcrumb?: Crumb[];
	variant?: "no-container" | "default" | "small";
	backUrl?: string;
	head?: {
		children?: any;
	};
}

const Layout = (props: LayoutProps) => {
	const auth = useAuth();
	const type = auth.type;
	const { children, title, hideNav, variant } = props;
	const { isModal } = useContext(ModalViewContext);
	const classes = ["layout", `layout_${type}`, "pb-12 md:pb-0"];
	if (props?.className) classes.push(props.className);
	if (auth?.type) classes.push(`is-${type}`);

	if (auth.type === "student") {
		return (
			<LayoutStudent
				{...props}
				variant={variant === "no-container" ? variant : undefined}
			>
				{typeof title === "string" && <SEO {...{ title }} />}

				{children}
			</LayoutStudent>
		);
	}

	if (auth.type === "company") {
		if (isModal) {
			return <>{children}</>;
		}
		return (
			<LayoutCompany {...props} variant={hideNav ? "medium" : variant}>
				{typeof title === "string" && <SEO {...{ title }} />}

				{children}
			</LayoutCompany>
		);
	}

	return <div className="flex flex-col flex-1">{children}</div>;
};

interface LayoutBackButtonProps {
	to: string;
	label?: string;
}

const LayoutBackButton = ({ label, to }: LayoutBackButtonProps) => {
	const backUrl = useParseBackUrl();
	const { t } = useTranslation("buttons");

	return (
		<div className="mb-8">
			<NavLink to={backUrl || to}>
				<i className="fas fa-arrow-left mr-2"></i>
				<strong>{backUrl ? t("back") : label}</strong>
			</NavLink>
		</div>
	);
};

Layout.BackButton = LayoutBackButton;
Layout.Header = LayoutHeader;

export default Layout;
